'use client';

import Image from 'next/image';

import { copy } from '@/data/copy';
import { ErrorBoundaryBase } from '@/components/utils/ErrorBoundaryBase';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <ErrorBoundaryBase
          error={error}
          reset={reset}
          description={copy.errorBoundary.globalErrorDescription}
          hideSecondaryAction
          errorHint="[GlobalError]"
          icon={
            <div className="bg-primary dark:bg-boxdark p-7 rounded-2xl">
              <Image
                width={350}
                height={150}
                src={'/logos/bwth-logo-light.svg'}
                alt="Logo"
              />
            </div>
          }
        />
      </body>
    </html>
  );
}
